import { call, put } from 'redux-saga/effects'
import { toast } from 'react-toastify';

import { loginService } from '../services'
import { LOGIN_SUCCESS } from '../actions/actionTypes';


export function* LoginRequest(action) {
    try {
      const user = yield call(loginService, action.data);
      
      if (user.data.status_code === 200) {
        toast.success(user.data.message[0], {
          position: toast.POSITION.TOP_RIGHT,
        });
        yield put({ type: LOGIN_SUCCESS, data: user.data.data });
      
      } else { 
        toast.error(user.data.message[0], {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
     
    } catch (e) {
      toast.error(e.response.data.message[0], {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
}
